import React from 'react';
import { useTranslation } from 'react-i18next';
import BenchmarkSection from '../BenchmarkSection';

const BenchmarkPage = ({ portfolioPercentage, ndaqPercentage, spyPercentage, arkkPercentage }) => {
  const { t } = useTranslation();

  return (
    <div className="content-section">
      <h2>{t('benchmark.title')}</h2>
      <div className="benchmark-section">
        {portfolioPercentage !== null && ndaqPercentage !== null && spyPercentage !== null && (
          <BenchmarkSection 
            portfolioPercentage={portfolioPercentage}
            ndaqPercentage={ndaqPercentage}
            spyPercentage={spyPercentage}
            arkkPercentage={arkkPercentage}
          />
        )}
      </div>
    </div>
  );
};

export default BenchmarkPage;
